import { gql } from '@apollo/client';
export const getProtocolNameOptionsQuery = gql `
  query performanceMetricsFilter($organizationID: ID!) {
    performanceMetricsFilter(organizationID: $organizationID) {
      protocolNames
    }
  }
`;
